
import { Entity } from '../entity';
import * as Enumerable from 'linq';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';
import { PaymentMethodEntity } from './payment';

export interface PaymentViewLookups {
    account?: Entity[];
    company?: Entity[];
    method?: PaymentMethodEntity[];
}

export interface PaymentViewFilters extends PaymentViewLookups {

    _id?: string;

    // Multi - Need to check data inside
    search?: string;
    date?: FiltersRelativeDateMethod;
}

export function effectivePaymentViewFilters(view: PaymentViewFilters, refinements: PaymentViewFilters) {

    const effective: { [k in keyof PaymentViewFilters] } = {} as PaymentViewFilters;
    const keys = Object.keys(new PaymentViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : view[key];
            }

            if (effective[key] == null || Object.keys(effective[key])?.length == 0) {
                delete effective[key];
            }
        });

    return effective;

}

export function isPaymentViewFiltersRefined(refinements: PaymentViewFilters): boolean {

    if (!refinements) return false;

    if (refinements.search && (refinements.search !== null || refinements.search === '')) return true;

    if (refinements?.account?.length) return true;
    if (refinements?.company?.length) return true;

    if (refinements?.method?.length) return true;

    if (refinements.date) return true;

    return false;
}


export class PaymentViewFiltersClass implements PaymentViewFilters {

    _id?: string;

    search?: string = null;

    account?: Entity[] = [];
    method?: PaymentMethodEntity[] = [];
    date?: FiltersRelativeDateMethod = null;
    company?: Entity[] = [];
}
